import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectNewbuildingsCompareBlocks,
  selectNewbuildingsComparison,
  selectNewbuildingsCount,
} from '../../selectors/newbuildingsCompare';
import { NewbuildingsCompareMobilePage } from '../../components/NewbuildingsCompareMobilePage';
import { NewbuildingCard } from '../../components/NewbuildingsCompareMobilePage/parts/NewbuildingCard';
import { NewbuildingFloatingCard } from '../../components/NewbuildingsCompareMobilePage/parts/NewbuildingFloatingCard';
import { buildNewbuildingsCompareViewRows } from '../NewbuildingsComparePage/buildViewRows';
import { AiBannerContainer } from '../AiBanner';
import { AiSummaryModalMobileContainer } from '../AiSummaryModalMobile';
import { useCompareZhkUxfbEvent } from '../../hooks/useCompareZhkUxfbEvent';

export const NewbuildingsCompareMobilePageContainer = () => {
  const comparison = useSelector(selectNewbuildingsComparison);
  const blocks = useSelector(selectNewbuildingsCompareBlocks);
  const newbuildingsCount = useSelector(selectNewbuildingsCount);

  useCompareZhkUxfbEvent('mobweb', newbuildingsCount);
  const [isRoomStatsExpanded, setRoomStatsExpanded] = React.useState(false);
  const [pinnedIndex, setPinnedIndex] = React.useState<number | null>(null);
  const [isAiSummaryModalOpen, setAiSummaryModalOpen] = React.useState(false);

  const handleToggleRoomStats = React.useCallback(() => setRoomStatsExpanded(value => !value), []);
  const handleTogglePin = React.useCallback(
    (index: number) => setPinnedIndex(prev => (prev === index ? null : index)),
    [],
  );
  const handleOpenAiSummaryModal = React.useCallback(() => setAiSummaryModalOpen(true), []);
  const handleAiSummaryModalOpenChange = React.useCallback((open: boolean) => setAiSummaryModalOpen(open), []);

  const { rows, summaryRow } = buildNewbuildingsCompareViewRows({
    blocks,
    platform: 'mobile',
    isRoomStatsExpanded,
    onToggleRoomStats: handleToggleRoomStats,
  });

  // Закрепление хранится по индексу колонки. При изменении набора ЖК (добавили/удалили/
  // переупорядочили) индексы сдвигаются, поэтому сбрасываем закрепление, чтобы оно не
  // «перепрыгнуло» на другой ЖК.
  const columnsKey = (summaryRow?.cells ?? []).map(cell => cell.data?.id ?? '').join(',');

  React.useEffect(() => {
    setPinnedIndex(null);
  }, [columnsKey]);

  if (!comparison) {
    return null;
  }

  const columns =
    summaryRow?.cells.map((cell, index) => (
      <NewbuildingCard
        cell={cell}
        isPinned={index === pinnedIndex}
        key={index}
        onTogglePin={() => handleTogglePin(index)}
      />
    )) ?? [];

  const floatingColumns =
    summaryRow?.cells.map((cell, index) => <NewbuildingFloatingCard cell={cell} key={index} />) ?? [];

  return (
    <>
      <NewbuildingsCompareMobilePage
        aiBanner={<AiBannerContainer mobile onOpen={handleOpenAiSummaryModal} />}
        columns={columns}
        floatingColumns={floatingColumns}
        pinnedIndex={pinnedIndex}
        rows={rows}
        title={comparison.title}
      />
      <AiSummaryModalMobileContainer onOpenChange={handleAiSummaryModalOpenChange} open={isAiSummaryModalOpen} />
    </>
  );
};
